<template>
  <section class="qrcode" v-html="qrcode()">
  </section>
</template>
<script>

import qrcode from 'qrcode-generator'


function QR(s, type, ecc) {
  let qr = qrcode(type || 8, ecc || 'L');
  qr.addData(s, undefined);
  qr.make();
  return qr;
}

export default {
    name: 'qrcode',
    props: {
        "data": {
            type: String,
            require: true,
        },
        "alt": {
            type: String,
            require: true,
        },
    },
    methods: {
      qrcode () {
          return QR(this.data).createImgTag(4, 0, this.alt);
      }
    },
}
</script>
<style>
  .qrcode {
  text-align: center;
  }
</style>
